<template>
  <div>
    <b-button variant="outline-light" v-on:click="detayaGit()">
      <Icon
        icon="akar-icons:search"
        width="25"
        height="25"
        v-b-tooltip.hover.bottom="'DETAY'"
        color="#7367F0"
      />
    </b-button>
    <b-button variant="outline-light" v-on:click="mesajGonder()">
      <Icon
        v-if="params.data.MSGDURUM == 'GÖNDER'"
        icon="material-symbols:send-time-extension-outline"
        width="25"
        height="25"
        color="#EA5455"
        v-b-tooltip.hover.bottom="'GÖNDER'"
      />
      <Icon
        v-else-if="params.data.MSGDURUM == 'GÖNDERİLDİ'"
        icon="ic:baseline-schedule-send"
        width="25"
        height="25"
        color="#FF9F43"
        v-b-tooltip.hover.bottom="'GÖNDERİLDİ'"
      />

      <Icon
        v-else
        icon="ic:baseline-schedule-send"
        width="25"
        height="25"
        color="#28C76F"
        v-b-tooltip.hover.bottom="'ONAYLANDI'"
      />
    </b-button>
    <b-button
      v-if="params.data.MSGDURUM == 'ONAYLANDI' && params.data.SIPDURUM == 0"
      variant="outline-light"
      v-on:click="activePrompt3 = true"
    >
      <Icon
        icon="material-symbols:order-approve-outline"
        width="25"
        height="25"
        color="#bc49c4"
        v-b-tooltip.hover.bottom="'SİPARİŞ OLUŞTUR'"
      />
    </b-button>

    <b-modal
      ref="modal-teklifgonder"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Teklif Onayı"
      size="lg"
      hide-footer
    >
      <div>
        <b-row>
          <vs-card>
            <vs-table stripe :data="cariList">
              <template slot="thead">
                <vs-th sort-key="ADI">Adı</vs-th>
                <vs-th sort-key="GSM">Telefon</vs-th>
                <vs-th sort-key="EMAIL">Mail</vs-th>
                <vs-th>Gönder</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].ADI">
                    {{ data[indextr].ADI }}
                  </vs-td>
                  <vs-td :data="data[indextr].GSM">
                    {{ data[indextr].GSM }}
                  </vs-td>
                  <vs-td :data="data[indextr].EMAIL">
                    {{ data[indextr].EMAIL }}
                  </vs-td>
                  <vs-td>
                    <b-button
                      variant="outline-light"
                      v-on:click="
                        gonderilecekCari = data[indextr];
                        promtBaslik = 'Mesaj Gönder';
                        activePrompt = true;
                      "
                    >
                      <Icon
                        icon="material-symbols:send-to-mobile-outline"
                        width="25"
                        height="25"
                        v-b-tooltip.hover.bottom="'Mesaj Gönder'"
                        color="#1E1E1E"
                      />
                    </b-button>

                    <b-button
                      variant="outline-light"
                      v-on:click="
                        gonderilecekCari = data[indextr];
                        promtBaslik = 'Mail Gönder';
                        activePrompt2 = true;
                      "
                    >
                      <Icon
                        icon="ic:round-schedule-send"
                        width="25"
                        height="25"
                        v-b-tooltip.hover.bottom="'Mail Gönder'"
                        color="#1E1E1E"
                      />
                    </b-button>
                  </vs-td>
                </vs-tr>

                <vs-tr> </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      ref="modal-teklifonay"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Teklif Onayı"
      size="lg"
      hide-footer
    >
      <div>
        <b-row>
          <vs-card>
            <b-row>
              <div id="invoice-page" v-if="Panel1Validate == true">
                <vs-card border="1">
                  <div slot="header">
                    <h3 class="text-danger">
                      İşlem Daha Önce Onaylanmış veya Onay Yetki Dışı ...
                    </h3>
                  </div>
                </vs-card>
              </div>

              <teklif-onay-mail-gonder
                ref="invoiceRef"
                :paramsData="params.data"
                :tarih="TARIH"
              >
                <template slot="action-buttons">
                  <table style="width: 100%" class="border-collapse">
                    <tr>
                      <td>
                        <h5 style="text-align: start">
                          {{ ACTNAME }}
                        </h5>
                        <h5 style="text-align: start">
                          {{ DESCRIPTION }}
                        </h5>
                      </td>
                      <td style="padding: 10px; text-align: right">
                        <p style="font-size: 18px">Tarih: {{ TARIH }}</p>
                        <p style="font-size: 18px">
                          Sıra No: {{ params.data.DOCUMENTNO }}
                        </p>
                      </td>
                    </tr>
                  </table>

                  <table
                    border="1"
                    style="border-top: 1px solid grey; width: 100%"
                    class="border-collapse"
                  >
                    <tr>
                      <td>
                        <table style="width: 100% !important; text-align: center">
                          <tr>
                            <th
                              sort-key="stokkodu"
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              RESIM
                            </th>

                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              STOK NO
                            </th>
                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              STOK ADI
                            </th>

                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              AÇIKLAMA
                            </th>
                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              MİKTAR
                            </th>
                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              FİYAT
                            </th>
                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              TUTAR
                            </th>
                          </tr>

                          <tr :key="indextr" v-for="(tr, indextr) in itemListele">
                            <td style="padding: 8px">
                              <img
                                :src="resimYazdir(tr.RESIM)"
                                alt=""
                                style="width: 80px"
                              />
                            </td>

                            <td style="padding: 8px">
                              {{ tr.STOCKNO }}
                            </td>
                            <td style="padding: 8px">
                              {{ tr.STOCKNAME }}
                            </td>
                            <td style="padding: 8px">
                              {{ tr.DESCRIPTION }}
                            </td>
                            <td style="padding: 8px">{{ tr.QUANTITY }}</td>
                            <td style="padding: 8px">
                              {{ currencyFormatter(tr.CURRPRICE, tr.CURRCODE) }}
                            </td>
                            <td style="padding: 8px">
                              {{ currencyFormatter(tr.CURRTOTAL, tr.CURRCODE) }}
                            </td>
                          </tr>
                          <tr>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>

                            <td style="font-weight: bold; padding: 8px">Ara Toplam:</td>
                            <td style="font-weight: bold; padding: 8px">
                              {{ currencyFormatter(araToplam, CURRCODE) }}
                            </td>
                          </tr>
                          <tr>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>

                            <td style="padding: 8px"></td>
                            <td style="font-weight: bold; padding: 8px">Kdv Toplam:</td>
                            <td style="font-weight: bold; padding: 8px">
                              {{ currencyFormatter(kdvToplam, CURRCODE) }}
                            </td>
                          </tr>
                          <tr>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>
                            <td style="padding: 8px"></td>

                            <td style="padding: 8px"></td>
                            <td style="font-weight: bold; padding: 8px">Gn Toplam:</td>
                            <td style="font-weight: bold; padding: 8px">
                              {{ currencyFormatter(gnToplam, CURRCODE) }}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <br />
                  </table>

                  <br />
                  <table style="width: 100%" class="border-collapse">
                    <tr>
                      <td style="padding: 10px; text-align: left">
                        <p
                          class="text-primary"
                          style="font-size: 15px; font-weight: bold"
                        >
                          ÖDEME ŞEKLİ :
                          <span style="font-weight: 500; color: black">{{
                            odemeSekli
                          }}</span>
                        </p>
                        <p
                          class="text-primary"
                          style="font-size: 15px; font-weight: bold"
                        >
                          SEVK ŞEKLİ :
                          <span style="font-weight: 500; color: black">{{
                            sevkSekli
                          }}</span>
                        </p>
                        <p
                          class="text-primary"
                          style="font-size: 15px; font-weight: bold"
                        >
                          NOTLAR :
                          <span style="font-weight: 500; color: black">{{ notlar }}</span>
                        </p>
                        <p>
                          Döviz fiyatları, teklifin kabulu halinde, fatura tarihinden bir
                          önceki günkü merkez bankası satış kurundan
                          faturalandırılacaktır.
                        </p>
                        <p
                          class="text-primary"
                          style="font-size: 15px; font-weight: bold"
                        >
                          Teklifi Hazırlayan :
                          <span style="font-weight: 500; color: black">{{
                            teklifiHazirlayan
                          }}</span>
                        </p>
                        <p
                          class="text-primary"
                          style="font-size: 15px; font-weight: bold"
                        >
                        Teslimat Adresi :
                          <span style="font-weight: 500; color: black"
                            >{{ adresTipi }}{{ adres }}</span
                          >
                        </p>
                      </td>
                    </tr>
                  </table>

                  <br />
                  <div style="height: 150px">
                    <table style="width: 100%">
                      <tr>
                        <td style="text-align: center; padding: 3px; font-weight: bold">
                          Gönderici Onayı
                        </td>
                        <td style="text-align: center; padding: 3px; font-weight: bold">
                          Whatsapp Alıcı Onayı
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            text-align: center;

                            padding: 3px;
                          "
                        >
                          DENİZLİ CANER LTD.
                        </td>
                        <td style="text-align: center; padding: 3px">
                          <p>{{ ACTNAME }}</p>
                          <p>{{ onayAdi }}</p>
                          <p>{{ onaylayan }}</p>
                          <p>{{ ipAdres }}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div>
                    <h6>
                      TEKLİFİ ONAYLADIYSANIZ, LÜTFEN YAZDIRIP, KAŞE VE İMZAYLA 258-2512943
                      NOLU TELEFONA FAKSLAYINIZ.
                    </h6>
                  </div>
                  <table
                    v-if="GridOnayValidate == true"
                    border="1"
                    style="border-top: 1px solid grey; width: 100%"
                    class="border-collapse"
                  >
                    <tr>
                      <td>
                        <table style="width: 100% !important; text-align: center">
                          <tr>
                            <th
                              sort-key="stokkodu"
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              GÖNDERİ TARİHİ
                            </th>

                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              ALICI
                            </th>
                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              GÖNDERİ TÜRÜ
                            </th>
                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              GÖNDEREN PERSONEL
                            </th>
                            <th
                              style="
                                text-align: center;
                                border-bottom: 1px solid grey;
                                padding: 3px;
                              "
                            >
                              ONAY TARİHİ
                            </th>
                          </tr>

                          <tr :key="indextr" v-for="(tr, indextr) in itemListGorev">
                            <td style="padding: 8px">
                              {{ parseDate(tr.GONDERITARIH) }}
                            </td>

                            <td style="padding: 8px">
                              {{ tr.ALICI }}
                            </td>
                            <td style="padding: 8px">
                              {{ tr.GONDERITUR }}
                            </td>
                            <td style="padding: 8px">{{ tr.GONDEREN }}</td>
                            <td style="padding: 8px">
                              {{ tr.ONAYTARIH }}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <br />
                  </table>
                </template>
              </teklif-onay-mail-gonder>
            </b-row>
          </vs-card>
        </b-row>
      </div>
    </b-modal>
    <vs-prompt
      :title="promtBaslik"
      acceptText="Gönder"
      cancelText="Vazgeç"
      @accept="wpmesajGonder"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <span>Gönderim işlemini tamamla</span>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
    <vs-prompt
      :title="promtBaslik"
      acceptText="Gönder"
      cancelText="Vazgeç"
      @accept="mailGonder"
      :active.sync="activePrompt2"
    >
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <span>Gönderim işlemini tamamla</span>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
    <vs-prompt
      title="Uyarı"
      acceptText="Dönüştür"
      cancelText="Vazgeç"
      @accept="siparisKaydet"
      :active.sync="activePrompt3"
    >
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <span>Bu Teklif Siparişe Dönüşecek. Eminmisiniz?</span>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import moment from "moment";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { Icon } from "@iconify/vue2";

import { BDropdown, BDropdownItem, VBTooltip } from "bootstrap-vue";
import TeklifOnayMailGonder from "./TeklifOnayMailGonder.vue";
import TeklifOnayMesaj from "../../../pages/TeklifOnayMesaj.vue";
export default {
  metaInfo() {
    return {
      title: "Caner Group",
      meta: [
        {
          name: "Bu ileti Caner Group tarafından gönderilen, teklif onayı içindir. ",
          content: "İşlemi onaylıyorum kısmına tıklayıp, onayla butonuna basınız.",
        },
      ],
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      CURRCODE: "",
      activePrompt3: false,
      gonderilecekCari: [],
      promtBaslik: "",
      activePrompt2: false,
      activePrompt: false,
      toplamTutar: 0.0,
      teklifOnayListDetay: [],
      itemListele: [],
      itemListGorev: [],

      ipAdres: "",
      TARIH: "",
      adres: "",
      adresTipi: "",
      aciklama: "",
      ACTNAME: "",
      DESCRIPTION: "",
      odemeSekli: "",
      sevkSekli: "",
      notlar: "",
      teklifiHazirlayan: "",
      onayAdi: "",
      cariAdi1: "",
      onaylayan: "",
      NotesId: "",
      araToplam: 0.0,
      kdvToplam: 0.0,
      gnToplam: 0.0,
      onay: "",
      mail: "",
      Panel1Validate: false,
      GridOnayValidate: false,
      DivOnayValidate: false,

      imgSrcUrl: "https://servis.kamyonyedekparca.com",
      cariList: [],
    };
  },
  components: { Icon, TeklifOnayMailGonder, TeklifOnayMesaj },
  methods: {
    siparisKaydet() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        RECEIPTID: vm.params.data.RECEIPTID,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_SIPARIS(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_SIPARISResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_SIPARISResult);
            if (vm.veriler.response == "Ok") {
              vm.mailGonder2(JSON.parse(vm.veriler.jsonData));
              vm.$root.$emit("teklidOnayListesi");
            }
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    teklifOnayIslem(due) {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(vm.gonderilecekCari);
      const args = {
        token: Store.state.tokenId,
        CariAd: vm.gonderilecekCari.ADI,
        cariTel: due == "MAIL" ? vm.gonderilecekCari.EMAIL : vm.gonderilecekCari.GSM,
        RECEIPTID: vm.params.data.RECEIPTID,
        TRANSTYPE: vm.params.data.TRANSTYPE,
        USERLONGNAME: Store.state.USERLONGNAME,
        due: due,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_MESAJ(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_MESAJResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_MESAJResult);
            vm.detayaGit();
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    mailGonder2(deger) {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};

      args = {
        ALICI: "volkancaner@canerotomotiv.com, Ufukbalci@canerotomotiv.com",
        MESAJ:
          deger[0].RECEIPTNO +
          ".Nolu Teklif  " +
          Store.state.USERLONGNAME +
          " Tarafından Siparişe Dönüşmüştür. ",
        KONU: "Teklif Onay",
      };
      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //vm.$store.dispatch('login', payload)
          }
          let veriler2 = JSON.parse(result.mailGonderResult);
          try {
            if (veriler2.response == "Ok") {
              vs.notify({
                title: "Mail",
                text: "Mail başarıyla gönderildi." + veriler2.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }
          } catch (error) {
            console.log(error);
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu." + veriler2.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    mailGonder() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};

      if (vm.gonderilecekCari.EMAIL == "") {
        vs.notify({
          title: "Teklif Onay",
          text: "Mail adresi bulunmuyor.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else {
        args = {
          ALICI: vm.gonderilecekCari.EMAIL,
          MESAJ:
            vm.gonderilecekCari.ADI +
            "</br>" +
            "Merhaba Bizden istemiş olduğunuz satış teklifi Denizli Caner Otomotiv San. Tic. A.Ş. " +
            vm.params.data.EMPLOYEENAME +
            " tarafından hazırlanmış ve Onayınızı beklemektedir, Aşağıdaki link'den onaylayabilirsiniz. Saygılamızla... " +
            "</br>" +
            " Onaylama için   https://int.kamyonyedekparca.com/teklif-onay-mesaj/" +
            vm.params.data.ID +
            "/" +
            vm.params.data.TRANSTYPE +
            "/" +
            vm.params.data.DOCUMENTNO +
            "/" +
            vm.gonderilecekCari.EMAIL +
            "</br> </br> </br> Saygılarımla",
          KONU: "Teklif Onay",
        };
        soap.createClient(url, function (err, client) {
          client.mailGonder(args, function (err, result) {
            if (result.mailGonderResult == "-1") {
              Store.dispatch("logout");
              //vm.$store.dispatch('login', payload)
            }
            let veriler2 = JSON.parse(result.mailGonderResult);
            try {
              if (veriler2.response == "Ok") {
                vm.teklifOnayIslem("MAIL");
                vs.notify({
                  title: "Mail",
                  text: "Mail başarıyla gönderildi." + veriler2.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              }
            } catch (error) {
              console.log(error);
              vs.notify({
                title: "Mail",
                text: "Mail göndermede hata oluştu." + veriler2.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
      }
    },
    wpmesajGonder() {
      if (this.gonderilecekCari.GSM == "") {
        this.$vs.notify({
          title: "Teklif Onay",
          text: "Cari Numarası bulunmuyor.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        let arg = {
          DOCUMENTNO: this.params.data.DOCUMENTNO,
          ID: this.params.data.ID,
          TRANSTYPE: this.params.data.TRANSTYPE,
        };
        try {
          if (this.gonderilecekCari.EMAIL == "") {
            const message = encodeURIComponent(
              `Merhaba Bizden istemiş olduğunuz satış teklifi Denizli Caner Otomotiv San. Tic. A.Ş. ` +
                this.params.data.EMPLOYEENAME +
                ` tarafından hazırlanmış ve Onayınızı beklemektedir, Aşağıdaki link'den onaylayabilirsiniz. Saygılamızla... `
            );
            const link = `https://int.kamyonyedekparca.com/teklif-onay-mesaj/${this.params.data.ID}/${this.params.data.TRANSTYPE}/${this.params.data.DOCUMENTNO}`;
            const whatsappLink = `https://wa.me/${this.gonderilecekCari.GSM.trim()}?text=${message}%20${link}`;
            window.open(whatsappLink, "_blank");
            this.teklifOnayIslem("MESAJ");
          } else {
            const message = encodeURIComponent(
              `Merhaba Bizden istemiş olduğunuz satış teklifi Denizli Caner Otomotiv San. Tic. A.Ş. ` +
                this.params.data.EMPLOYEENAME +
                ` tarafından hazırlanmış ve Onayınızı beklemektedir, Aşağıdaki link'den onaylayabilirsiniz. Saygılamızla... `
            );
            const link = `https://int.kamyonyedekparca.com/teklif-onay-mesaj/${this.params.data.ID}/${this.params.data.TRANSTYPE}/${this.params.data.DOCUMENTNO}/${this.gonderilecekCari.EMAIL}`;
            const whatsappLink = `https://wa.me/${this.gonderilecekCari.GSM.trim()}?text=${message}%20${link}`;
            window.open(whatsappLink, "_blank");
            this.teklifOnayIslem("MESAJ");
          }
        } catch (error) {}
      }
    },
    mesajGonder() {
      let LblSecIslem = this.params.data.TRANSTYPE;
      let BtnDurum = this.params.data.MSGDURUM;
      let LblSecFisId = this.params.data.RECEIPTID;
      let LblSecCariId = this.params.data.ACTID;
      let Tarih = moment(this.params.data.TARIH, "DD.MM.YYYY").format("MM/DD/YYYY hh:mm");
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      function dateDiffInDays(a, b) {
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      }
      let today = new Date();
      const a = new Date(today),
        b = new Date(Tarih),
        difference = dateDiffInDays(a, b);

      if (difference > 10 || isNaN(difference)) {
        this.$vs.notify({
          title: "Teklif Onay",
          text: "Bu Teklifin geçerliliği Bitmiştir.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        //   this.iletisimGetir(LblSecCariId);
        if (BtnDurum == "GÖNDER" || BtnDurum == "GÖNDERİLDİ") {
          this.iletisimGetir(LblSecCariId);
        } else {
          this.$vs.notify({
            title: "Teklif Onay",
            text: "Bu İşlem Onaylanmıştır.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            position: "top-center",
          });
        }
      }
    },
    iletisimGetir(CariId) {
      this.$refs["modal-teklifgonder"].show();
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        CariId: CariId,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_ILETISIM_LIST(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_ILETISIM_LISTResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_ILETISIM_LISTResult);

            vm.cariList = JSON.parse(vm.veriler.jsonData);
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    resimYazdir(url) {
      var changedPicture = url;
      if (url.toString().includes("~") == true) {
        changedPicture = url.toString().replace("~", "");
      }
      this.imgSrc = this.imgSrcUrl + changedPicture;
      return this.imgSrc;
    },
    parseDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${formatted} ` + sign;
    },

    getDetayOnayList() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        RECEIPTID: vm.params.data.ID,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_DETAY_ONAY(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_DETAY_ONAYResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_DETAY_ONAYResult);
            vm.itemListGorev = JSON.parse(vm.veriler.jsonData);
          } catch (error) {
            console.log(error);
          }
        });
      });
    },

    getDetayList() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ID: vm.params.data.ID,
        TRANSTYPE: vm.params.data.TRANSTYPE,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_DETAY_LIST(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_DETAY_LISTResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_DETAY_LISTResult);
            vm.itemListele = JSON.parse(vm.veriler.jsonData);
            vm.CURRCODE = vm.itemListele[0].CURRCODE;
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    detayaGit() {
      this.$refs["modal-teklifonay"].show();
      var vm = this;
      vm.getDetayList();
      vm.getDetayOnayList();
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ID: vm.params.data.ID,
        TRANSTYPE: vm.params.data.TRANSTYPE,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_DETAY(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_DETAYResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_DETAYResult);

            let list = JSON.parse(vm.veriler.jsonData);

            vm.sevkSekli = list[0].DESCRIPTION2;
            vm.odemeSekli = "Fatura tarihinden itibaren " + list[0].DUEDAY + " gündür";
            vm.ipAdres = list[0].IP;
            vm.TARIH = list[0].TARIH;
            vm.aciklama = list[0].DESCRIPTION;
            vm.ACTNAME = list[0].ACTNAME;
            vm.DESCRIPTION = list[0].DESCRIPTION;
            vm.onayAdi = list[0].CHECKMD5SUM;
            vm.cariAdi1 = list[0].ACTNAME;
            vm.onaylayan = list[0].NAME2;
            vm.NotesId = list[0].NOTEID;
            vm.araToplam = list[0].NETTOPLAM;
            vm.kdvToplam = list[0].VATSUM;
            vm.gnToplam = list[0].TOTAL;
            vm.onay = list[0].APPROVE3;
            vm.mail = list[0].MAIL;
            vm.teklifiHazirlayan = vm.params.data.EMPLOYEENAME;
            vm.adres = list[0].ADRES;
            vm.adresTipi = list[0].ADRESBASLIK;
            /*
            let LblGelenId = "",
              LblTur = "",
              LblCode = "",
              LblAp = "1";
            let sayiBul, RecBul;
            let Gelen = vm.params.data.ID.split("");
 
            if (Gelen.includes("CCC") == true)
              sayiBul = parseInt(Gelen.indexOf("CCC=").toString());
            if (Gelen.includes("-") == true)
              RecBul = parseInt(Gelen.indexOf("-").toString());
            let GelenUzunluk = vm.params.data.ID.Length;
 
            if (GelenUzunluk > 12) {
              LblGelenId = vm.params.data.ID.substring(4, sayiBul - RecBul - 1);
              LblTur = vm.params.data.ID.substring(0, 3);
              LblCode = vm.params.data.ID.substring(
                sayiBul,
                GelenUzunluk - sayiBul
              ).replace("CCC=", "");
              LblAp = "0";
            } else {
              LblGelenId = vm.params.data.ID.substring(
                4,
                vm.params.data.ID.Length - 4
              );
              LblTur = vm.params.data.TRANSTYPE.toString();
              LblAp = "1";
            }*/
            if (
              vm.onay == true ||
              vm.onay == "True" ||
              vm.params.data.MSGDURUM == "GÖNDERİLDİ"
            ) {
              //|| LblAp == "1"
              vm.Panel1Validate = true;
              vm.GridOnayValidate = true;
              vm.DivOnayValidate = false;
              //Detay();
              //OnayListe();
            } else {
              vm.DivOnayValidate = true;
              vm.GridOnayValidate = false;
            }

            const args2 = {
              token: Store.state.tokenId,
              NotesId: vm.NotesId,
            };
            soap.createClient(url, function (err, client) {
              client.INT_LS_TEKLIF_ONAY_NOTLAR(args2, function (err, result) {
                if (result.INT_LS_TEKLIF_ONAY_NOTLARResult == "0") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                try {
                  vm.veriler2 = JSON.parse(result.INT_LS_TEKLIF_ONAY_NOTLARResult);

                  let list2 = JSON.parse(vm.veriler2.jsonData);
                  vm.notlar = list2[0].NOTES;
                } catch (error) {
                  console.log(error);
                }
              });
            });
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
  },
  created() {},
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.rag-amber {
  background-color: lightsalmon;
}

.rag-blue {
  background-color: lightblue;
}

.rag-green {
  background-color: lightgreen;
}

.con-vs-dialog {
  z-index: 52005555;
}
</style>
